<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- PPR번호 -->
							<th class="col-1">* {{ getMessage_('QWCC001034') }}</th>
							<td class="position-relative">
								<el-input v-model="detailForm.pprNo" readOnly />
							</td>
							<!-- 검사번호 -->
							<th class="col-1">{{ getMessage_('QWCC000005') }}</th>
							<td class="position-relative">
								<div @click="() => onPageMove('1')">
									<el-input v-model="detailForm.ckuNo" readOnly />
								</div>
							</td>
							<!-- OS_D번호 -->
							<th class="col-1">{{ getMessage_('QWCC001463') }}</th>
							<td class="position-relative">
								<el-input v-model="detailForm.overSrgNo" readOnly />
							</td>
							<!-- 진행상태 -->
							<th class="col-1">{{ getMessage_('QWCC001094') }}</th>
							<td class="position-relative">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.pgsStCd"
									:options="getPgsStLpCdList_"
									:onChange="value => onChangeParam({ key: 'pgsStCd', value })"
									disabled
								/>
							</td>
							<!-- 메일발송 -->
							<th class="col-1">{{ getMessage_('QWCC001486') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.sndStCd"
									:options="getSndStCdList_"
									:onChange="val => onChangeParam(val, 'sndStCd')"
									:placeholder="getMessage_('QWCC001094')"
									disabled
								/>
							</td>
						</tr>
						<tr>
							<!-- 품번 -->
							<th class="col-1">{{ getMessage_('QWCC000956') }}</th>
							<td><el-input v-model="detailForm.partNo" readOnly /></td>
							<!-- 품명 -->
							<th class="col-1">{{ getMessage_('QWCC000957') }}</th>
							<td><el-input v-model="detailForm.partNm" readOnly /></td>
							<!-- LOT번호(FR) -->
							<th class="col-1">{{ getMessage_('QWCC001470') }}</th>
							<td>
								<el-input
									v-model="detailForm.lotFromNo"
									@input="value => onChangeParam_text('lotFromNo', value, 10)"
									:readOnly="getEditChk"
								/>
							</td>
							<!-- LOT번호(TO) -->
							<th class="col-1">{{ getMessage_('QWCC001469') }}</th>
							<td>
								<el-input v-model="detailForm.lotToNo" @input="value => onChangeParam_text('lotToNo', value, 10)" :readOnly="getEditChk" />
							</td>
							<!-- 납품업체 -->
							<th class="col-1">{{ getMessage_('QWCC001341') }}</th>
							<td class="position-relative">
								<!-- <el-input v-model="detailForm.cofCd" maxlength="20" show-word-limit /> -->

								<el-input
									v-model="detailForm.cofNm"
									maxlength="10"
									class="inputWithIcon"
									:placeholder="getMessage_('QWCC001341')"
									@input="value => onChangeParam({ key: 'cofNm', value })"
									:readOnly="getEditChk"
								/>
								<span class="unit input-icon" @click="() => onCommPopup('cofNm')"> <i class="icon-sf-search" /> </span>
							</td>
						</tr>
						<tr>
							<!-- 긴급도 -->
							<th class="col-1">{{ getMessage_('QWCC001418') }}</th>
							<td class="position-relative">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.lugyCd"
									:options="getLugyCdList_"
									:onChange="value => onChangeParam({ key: 'lugyCd', value })"
									:disabled="getEditChk"
								/>
							</td>
							<!-- 발생장소 -->
							<th class="col-1">{{ getMessage_('QWCC001464') }}</th>
							<td class="position-relative">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.occuPlCd"
									:options="getOccuPlCdList_"
									:onChange="value => onChangeParam({ key: 'occuPlCd', value })"
									:disabled="getEditChk"
								/>
							</td>
							<!-- 검사수량 -->
							<th class="col-1">{{ getMessage_('QWCC000073') }}</th>
							<td class="position-relative">
								<el-input
									v-model="detailForm.ckuQty"
									maxlength="7"
									show-word-limit
									@input="value => inputNumber({ key: 'ckuQty', value })"
									:readOnly="getEditChk"
								/>
							</td>
							<!-- 불량수량 -->
							<th class="col-1">* {{ getMessage_('QWCC000074') }}</th>
							<td class="position-relative">
								<el-input
									v-model="detailForm.badQty"
									maxlength="7"
									show-word-limit
									@input="value => inputNumber({ key: 'badQty', value })"
								/>
							</td>
							<!-- 격리수량 -->
							<th class="col-1">{{ getMessage_('QWCC001465') }}</th>
							<td class="position-relative">
								<el-input
									v-model="detailForm.sprtQty"
									maxlength="7"
									show-word-limit
									@input="value => inputNumber({ key: 'sprtQty', value })"
									:readOnly="getEditChk"
								/>
							</td>
						</tr>
						<tr>
							<!-- 발생일자 -->
							<th class="col-1">{{ getMessage_('QWCC001032') }}</th>
							<td class="position-relative">
								<el-date-picker
									v-model="detailForm.occuDd"
									type="date"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:disabled="getEditChk"
								/>
							</td>
							<!-- 제기일 -->
							<th class="col-1">{{ getMessage_('QWCC002059') }}</th>
							<td class="position-relative">
								<el-date-picker
									v-model="detailForm.pprsDd"
									type="date"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:disabled="getEditChk"
								/>
							</td>
							<!-- 라인정지시간 -->
							<th class="col-1">{{ getMessage_('QWCC001419') }}</th>
							<td class="position-relative">
								<el-input
									v-model="detailForm.lnStpTm"
									:clearable="false"
									maxlength="4"
									show-word-limit
									@input="value => inputNumber({ key: 'lnStpTm', value })"
									:readOnly="getEditChk"
								/>
							</td>
							<!-- 결함유형 -->
							<th class="col-1">* {{ getMessage_('QWCC001468') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="detailForm.badTypeSgrpNm"
												class="inputWithIcon"
												@keyup.native.delete="() => onBadTypeInPutKeyDown()"
												:readonly="true"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onBadTypeSearchPopup()"></i>
										</div>
									</el-col>
								</div>
								<!-- <sf-select-group
									labelPosition="left"
									:inputValue="detailForm.badTypeLgrpCd"
									:options="getBadTypeLgrpList_"
									:onChange="value => onChangeParam({ key: 'badTypeLgrpCd', value })"
								/> -->
							</td>
							<!-- 소싱구분 -->
							<th class="col-1">{{ getMessage_('QWCC000981') }}</th>
							<td class="position-relative">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.partGCd"
									:options="getPartGCdList_"
									:onChange="value => onChangeParam({ key: 'partGCd', value })"
									:disabled="true"
								/>
							</td>
							<!-- <td class="position-relative">
								<el-input v-model="detailForm.partGCd" />
							</td> -->
						</tr>
						<tr>
							<!-- 대책회신 -->
							<th class="col-1">{{ getMessage_('QWCC001436') }}</th>
							<td class="position-relative">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.mdvRplCd"
									:options="getMdvRplCdList_"
									:onChange="value => onChangeParam({ key: 'mdvRplCd', value })"
									:disabled="getEditChk"
								/>
							</td>
							<!-- 회신내용 -->
							<td colspan="2" class="position-relative">
								<el-input v-model="detailForm.rplSbc" @input="value => onChangeParam_text('rplSbc', value, 100)" :readOnly="getEditChk" />
							</td>
							<!-- 회신요구일 -->
							<th class="col-1">{{ getMessage_('QWCC001420') }}</th>
							<td class="position-relative">
								<el-date-picker
									v-model="detailForm.rplRqDd"
									type="date"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:disabled="onChkMdvRplCd"
								/>
							</td>
							<!--  -->
							<th class="col-1"></th>
							<td class="position-relative"></td>
							<!--  -->
							<th class="col-1"></th>
							<td class="position-relative"></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { getLimitedByteText } from '@/qmsUtils';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';
import PartCku from '@pqy/pcku/PartCku/PartCku';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			altrNumber: ''
		};
	},
	async mounted() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		// 대책회신 기준으로 활성화, 비활성화
		onChkMdvRplCd() {
			const mdvRplCd = this.detailForm.mdvRplCd;
			if (mdvRplCd === 'RPL10') {
				return false;
			} else {
				return true;
			}
		},
		// 진행상태에 따른 edit여부
		getEditChk() {
			let editYn = false;
			const pgsStCd = this.detailForm.pgsStCd;
			if (pgsStCd !== undefined && Number(pgsStCd) > 10) {
				editYn = true;
			}
			//console.log('PopupFormInfo getEditChk , pgsStCd>>> ', editYn, pgsStCd);
			return editYn;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangeParam(payload) {
			this.$sf_toggleLoading(true);
			// console.log('payload >>> ', payload);
			this.onChangeParam_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		onChangeParam_text(key, value, maxByte) {
			maxByte ? this.onChangeParam_({ key, value: getLimitedByteText(value, maxByte) }) : this.onChangeParam({ key, value });
		},
		onBadTypeInPutKeyDown() {},
		onBadTypeSearchPopup() {
			let sendParams = {};
			this.$emit('BadTypePopupOpen', sendParams);
		},
		//숫자입력체크
		inputNumber({ key, value }) {
			let numberRegEx = /[^0-9]/g; //숫자만 입력가능
			let val = value.replace(numberRegEx, '');
			this.onChangeParam_({ key: key, value: val });
		},
		onCommPopup() {
			let params = {
				cpnyScn: '10',
				cofCd: this.detailForm.cofCd,
				cofNm: this.detailForm.cofNm
			};

			this.$emit('CpnyPopupOpen', params);
		},
		// 검사번호 클릭시 부품검사 화면으로 이동
		async onPageMove(params) {
			//console.log('부품검사 화면으로 이동', this.partCkuScrId);

			const { partNo, ckuNo } = this.detailForm;
			if (partNo != '' && ckuNo != '' && this.partCkuScrId != '') {
				const name = this.getMessage_('QWCC000938');
				let item = {
					name,
					component: PartCku,
					scrId: this.partCkuScrId, //이동할 scrId
					msgKey: 'QWCC000938'
				};

				await this.getScreen_({ scrId: item.scrId });
				await this.$sf_removeTab(item.scrId);
				await this.$sf_addTab(item, item.scrId, { scrId: item.scrId, partNo, ckuNo });
			}
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -1px;
}
</style>
